import axios from 'axios';
import App from '@/assets/app.js';

axios.defaults.timeout = 10000;

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';

var navLang = navigator.language || navigator.userLanguage;
console.log(navLang);
// axios.defaults.headers.get['Content-Type'] = 'application/json;charset=utf-8';

// axios.defaults.baseURL = 'http://192.168.31.93:6785/'; 
// axios.defaults.baseURL = 'https://hk.qmisit.com:3785/'; 

//POST傳參序列化(添加請求連接器)
axios.interceptors.request.use((config) => {
	//發送請求前
	if (config.method === 'get') {
		config.data = true;
	} else {
		if (location.protocol == 'https:') { //正式
			config.baseURL = 'https://hk.qmisit.com:3785/'; //正式
		}else { //測試 localhost
			// config.baseURL = 'http://192.168.31.238:3785/';//本地
			config.baseURL = 'http://202.130.113.149:3785/'; //測試
			// config.baseURL = 'https://hk.qmisit.com:3785/'; //正式
		}
		// config.baseURL = 'https://hk.qmisit.com:3785/'; //正式
		// config.baseURL = 'http://192.168.31.93:6785/';

	}
	return config;
}, (error) => {

	console.log('錯誤傳參')
	return Promise.reject(error);
});


//返回一個Promise(發送post請求)login用
export function fetchLoginPost(url, params) {
	return new Promise((resolve, reject) => {
		axios.post(url, params).then(response => {
			if (Object.is(response.status, 200)) {
				resolve(response.data);
			}
		}, err => {
			if (navLang == 'zh-CN') {
				App.oTool.warningT('網絡訊號不穩定，請稍後再試。')
			}else{
				App.oTool.warningT('Network signal is unstable, please try again later.')

			}
			reject(err);
		}).catch((error) => {
			reject(error);
		});
	})
}


//返回一個Promise(發送post請求)
export function fetchPost(url, params, header) {
	return new Promise((resolve, reject) => {
		axios.defaults.headers.common["token"] = header.token;
		axios.post(url, Object.assign(params)).then(response => {
			if (Object.is(response.status, 200)) {
				if (Object.is(response.data.qmiscode, 3000) || Object.is(response.data.qmiscode,
					2000)) {
					setTimeout(() => {
						location.href = './';
					}, 1500);
				} else {
					resolve(response.data);
				}
			}
		}, err => {

			if (navLang == 'zh-CN') {
				App.oTool.warningT('網絡訊號不穩定，請稍後再試。')
			}else{
				App.oTool.warningT('Network signal is unstable, please try again later.')

			}
			reject(err);
		}).catch((error) => {
			reject(error);
		});
	})
}

////返回一个Promise(发送get请求) pdf
export function fetchGetPdf(url) {
	return new Promise((resolve, reject) => {
		axios({
			method: 'GET',
			url: url,
			responseType: 'blob'
		}).then((res) => {
			resolve(res.data);
		}, err => {
			if (navLang == 'zh-CN') {
				App.oTool.warningT('網絡訊號不穩定，請稍後再試。')
			}else{
				App.oTool.warningT('Network signal is unstable, please try again later.')

			}
			reject(err);
		}).catch((error) => {
			if (navLang == 'zh-CN') {
				App.oTool.warningT('網絡訊號不穩定，請稍後再試。')
			}else{
				App.oTool.warningT('Network signal is unstable, please try again later.')

			}
			reject(error);
		})
	})
}


export default {
	fetchLoginPost,
	fetchPost,
	fetchGetPdf
}
